export default __webpack_public_path__ + "static/11-3699d839c23b3d2056f6cd361394b75a.jpg";